export default "__VITE_ASSET__Di4rZfRG__"